import { ActionType } from 'redux/actions/intakeForm';
import { IReduxAction } from 'typings/common';
import { IntakeFormStatus } from 'api/crm/intakeFormAPI';

export type IntakeFormData = {
  _id: string;
  hrid: string;
  state: IntakeFormStatus;
  type: string;
  directClientName: string;
  keyRelationshipTemplateName: string;
};

export interface StateModel {
  intakeFormId: string | null;
  intakeForm: IntakeFormData | null;
  intakeSubmissions: IntakeFormData[];
}

const initialState: StateModel = {
  intakeFormId: null,
  intakeForm: null,
  intakeSubmissions: [],
};

const intakeForm = (state = initialState, action: IReduxAction) => {
  const { type, payload } = action;

  switch (type) {
    case ActionType.SET_INTAKE_FORM:
      return {
        ...state,
        intakeForm: payload,
      };

    case ActionType.SET_INTAKE_SUBMISSIONS:
      return {
        ...state,
        intakeSubmissions: payload,
      };

    case ActionType.SET_INTAKE_FORM_ID:
      return {
        ...state,
        intakeFormId: payload,
      };

    case ActionType.CLEAN_UP:
      return {
        ...initialState,
      };

    default:
      return state;
  }
};

export default intakeForm;
